






































import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '@/author/constants';
import { EmailType } from '@/author/components/EmailParts/EmailType';
import Modal from './Modal.vue';

@Component
export default class EmailPart extends Vue {
  @Prop() modal!: boolean;
  @Prop() imageModal?: string;
  @Prop() modalAlt?: string;
  @Prop() modalTitle?: string;
  @Prop() modalSubtitle?: string;
  @Prop() modalVideo?: string;
  @Prop() modalVtt?: string;
  @Prop() modalCompletionByInnerComponent?: boolean;
  @Prop() modalFullLocked?: boolean;
  @Prop() prefix?: string;
  @Prop() content?: string;
  @Prop() type!: EmailType;
  @Prop() imageSrc?: string;
  @Prop() imageAlt?: string;
  @Prop() arrowLeft?: boolean;
  @Prop() incorrect?: boolean;
  @Prop() ariaLabeledby?: string;
  @Prop() ariaDescribedby?: string;

  completed: boolean = false;
  showFeedback: boolean = false;

  handleModalComplete() {

    if (!this.getModalCompletion()) {
        this.showFeedback = true;
        this.completed = true;
    }
    this.$parent.$emit(EVENTS.COMPLETED, this.hash);
  }

  public isCompleted() {
    return this.completed;
  }

  mounted() {
    if (!this.modal) {
      this.handleModalComplete();
    }
    if(this.incorrect){
      this.completed = true;
    }
  }

  get hash(){
    if(!this.modal) return ''
    return (this.$children[0] as Modal).hash
  }

  public getModalCompletion(){
    return this.modalFullLocked || this.modalCompletionByInnerComponent
  }

}
